var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiagnosis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#EAEFFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 15V25C10.9998 28 12.4998 30 15.9998 30H23.9998C27.4998 30 28.9998 28 28.9998 25V15C28.9998 12 27.4998 10 23.9998 10H15.9998C12.4998 10 10.9998 12 10.9998 15Z",
    stroke: "#3969E7",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4998 12.5V14.5C17.4998 15.6 16.5998 16.5 15.4998 16.5H13.4998",
    stroke: "#3969E7",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5197 23.4901C24.8497 22.4601 24.4598 21.1901 23.3898 20.8401C22.8198 20.6601 22.1198 20.8101 21.7298 21.3601C21.3598 20.7901 20.6298 20.6601 20.0698 20.8401C18.9898 21.1901 18.6097 22.4601 18.9297 23.4901C19.4397 25.1201 21.2298 25.9701 21.7298 25.9701C22.2198 25.9601 23.9897 25.1301 24.5197 23.4901Z",
    stroke: "#3969E7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagnosis);
export default __webpack_public_path__ + "static/media/diagnosis.2486f25527e584cbe670e2ba5bdcb7bb.svg";
export { ForwardRef as ReactComponent };